export const esWallets = {
  'wallets.add': 'Agregar wallet',
  'wallets.balance': 'Saldo actual',
  'wallets.balanceFromMovements':
    'El saldo se calcula automáticamente desde los movimientos que apuntan a esta wallet.',
  'wallets.balanceModeHelp':
    'Activado: saldo acumulado al cierre. Desactivado: solo actividad del mes.',
  'wallets.color': 'Color',
  'wallets.confirmDelete': 'Sí, eliminar wallet',
  'wallets.debtAmount': 'Deuda inicial',
  'wallets.debtAmountHelp':
    'Escribe cuánto debes; FinanceGo lo registra como pasivo. Los intereses se configurarán cuando se definan sus reglas.',
  'wallets.delete': 'Eliminar wallet',
  'wallets.deleteBlocked': 'Cash es la wallet principal y no se puede eliminar.',
  'wallets.deleteLinked':
    'Esta wallet tiene movimientos. Elige cómo resolverlos antes de borrarla.',
  'wallets.deleteTransactions': 'Eliminar todos los movimientos asociados',
  'wallets.deleteTransactionsHelp': 'También elimina sus validaciones de agenda.',
  'wallets.description':
    'Cada wallet es una línea financiera independiente. Las transferencias conectan sus saldos sin alterar el total global.',
  'wallets.edit': 'Editar wallet',
  'wallets.done': 'Listo',
  'wallets.empty': 'Crea tu primera wallet para separar el dinero por propósito.',
  'wallets.error': 'No pudimos guardar la wallet. Revisa los datos e inténtalo de nuevo.',
  'wallets.fixed': 'Wallet principal',
  'wallets.filterDescription':
    'Los cambios se reflejan detrás del filtro para que puedas comparar el resultado.',
  'wallets.filterTitle': 'Filtrar wallets',
  'wallets.name': 'Nombre',
  'wallets.movements': '{count} movimientos vinculados',
  'wallets.moveTransactions': 'Mover movimientos a otra wallet',
  'wallets.moveTransactionsHelp': 'Las transferencias que quedarían contra sí mismas se eliminan.',
  'wallets.noReplacement': 'Crea otra wallet antes de mover los movimientos.',
  'wallets.projected': 'Proyectado',
  'wallets.projectedAt': 'Proyección a {period}',
  'wallets.selectedBalance': 'Saldo al cierre de {period}',
  'wallets.selectedPeriod': 'Actividad de {period}',
  'wallets.save': 'Guardar wallet',
  'wallets.title': 'Tus wallets',
  'wallets.total': 'Saldo global',
  'wallets.throughDate': 'Acumular hasta la fecha',
  'wallets.type': 'Tipo de wallet',
  'wallets.typeCash': 'Efectivo',
  'wallets.typeChecking': 'Cuenta corriente',
  'wallets.typeCredit': 'Crédito',
  'wallets.typeLoan': 'Préstamo',
  'wallets.typeOther': 'Otra',
  'wallets.typeSaving': 'Ahorros',
} as const;

export const enWallets: Record<keyof typeof esWallets, string> = {
  'wallets.add': 'Add wallet',
  'wallets.balance': 'Current balance',
  'wallets.balanceFromMovements':
    'The balance is calculated automatically from movements assigned to this wallet.',
  'wallets.balanceModeHelp':
    'On: accumulated closing balance. Off: activity only for the selected month.',
  'wallets.color': 'Color',
  'wallets.confirmDelete': 'Yes, delete wallet',
  'wallets.debtAmount': 'Opening debt',
  'wallets.debtAmountHelp':
    'Enter how much you owe; FinanceGo records it as a liability. Interest will be added after its rules are defined.',
  'wallets.delete': 'Delete wallet',
  'wallets.deleteBlocked': 'Cash is the main wallet and cannot be deleted.',
  'wallets.deleteLinked':
    'This wallet has movements. Choose how to resolve them before deleting it.',
  'wallets.deleteTransactions': 'Delete every associated movement',
  'wallets.deleteTransactionsHelp': 'Its agenda validations are deleted too.',
  'wallets.description':
    'Each wallet is an independent financial timeline. Transfers connect balances without changing the global total.',
  'wallets.edit': 'Edit wallet',
  'wallets.done': 'Done',
  'wallets.empty': 'Create your first wallet to separate money by purpose.',
  'wallets.error': 'We could not save the wallet. Review the data and try again.',
  'wallets.fixed': 'Main wallet',
  'wallets.filterDescription': 'Changes appear behind the filter so you can compare the result.',
  'wallets.filterTitle': 'Filter wallets',
  'wallets.name': 'Name',
  'wallets.movements': '{count} linked movements',
  'wallets.moveTransactions': 'Move movements to another wallet',
  'wallets.moveTransactionsHelp': 'Transfers that would point to themselves are removed.',
  'wallets.noReplacement': 'Create another wallet before moving movements.',
  'wallets.projected': 'Projected',
  'wallets.projectedAt': '{period} projection',
  'wallets.selectedBalance': 'Closing balance for {period}',
  'wallets.selectedPeriod': 'Activity for {period}',
  'wallets.save': 'Save wallet',
  'wallets.title': 'Your wallets',
  'wallets.total': 'Global balance',
  'wallets.throughDate': 'Accumulate through date',
  'wallets.type': 'Wallet type',
  'wallets.typeCash': 'Cash',
  'wallets.typeChecking': 'Checking',
  'wallets.typeCredit': 'Credit',
  'wallets.typeLoan': 'Loan',
  'wallets.typeOther': 'Other',
  'wallets.typeSaving': 'Savings',
};
